import { axiosCitajteo } from "../../axios/citajteo_axios";
import { DlGroup } from "type/dl_group/dl_group.type";
import { GroupSearchOptions } from "constant/dl_group/dl_group.constant";

export const groupGet = async (
  id: string,
  searchBy: string = "id"
): Promise<any> => {
  let result: DlGroup | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.get(`dl-group/${id}?searchBy=${searchBy}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export type GroupSearchParams = Partial<
  Record<GroupSearchOptions, number | string>
>;

export type GroupAddParams = {
  slug: string;
  fCond: Record<string, string>;
  groups: string[];
};

export type GroupUpdateParams = Partial<GroupAddParams>;

const groupResponseFormat = (unit: any): any => {
  const result = { ...unit };

  return result;
};

export const groupSearch = async (
  searchParams?: GroupSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(`dl-group/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) => groupResponseFormat(item));
  }

  return result;
};

export const groupAdd = async (
  addParams: GroupAddParams
): Promise<string | null> => {
  let result: string | null = null;
  let response: any;

  try {
    response = await axiosCitajteo.post("dl-group", addParams);
  } catch (error) {
    console.log("groupAdd - error", error);
  }

  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

export const groupUpdate = async (
  id: string,
  updatePayload: GroupUpdateParams
): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.put(`dl-group/${id}`, updatePayload);
  } catch (error) {
    console.log("groupUpdate - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};

export const groupDelete = async (id: string): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.delete(`dl-group/${id}`);
  } catch (error) {
    console.log("groupDelete - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};
